import { render, staticRenderFns } from "./_base-TooltipButton.vue?vue&type=template&id=831abf72&scoped=true"
import script from "./_base-TooltipButton.vue?vue&type=script&lang=js"
export * from "./_base-TooltipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831abf72",
  null
  
)

export default component.exports